import { Injectable } from "@angular/core";
import { Geolocation, Position } from "@capacitor/geolocation";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  canUseDeviceLocation$ = new BehaviorSubject<boolean>(true);
  disableDeviceLocationToggle$ = new BehaviorSubject<boolean>(false);

  constructor() {

  }

  public requestPermissions(): Observable<boolean> {
    Geolocation.checkPermissions().then(permissionStatus => {
      this.canUseDeviceLocation$.next(permissionStatus.location !== 'denied');
    });

    return this.canUseDeviceLocation$.asObservable();
  }

  public getCurrentPosition(): Promise<Position> {
    return Geolocation.getCurrentPosition();
  }
}
